import { getSchedulingTypes } from "@/services/scheduling";

export default {
  namespaced: true,
  state: {
    scheduling_types: []
  },
  getters: {
    getSchedulingTypes(state) {
      return state.scheduling_types;
    }
  },
  mutations: {},
  actions: {
    async loadSchedulingTypes({ state }) {
      if (state.scheduling_types.length == 0) {
        try {
          const types = await getSchedulingTypes();
          state.scheduling_types = types ? types : [];
        } catch (error) {
          console.error("erro ao buscar tipos de agendamento", error);
        }
      } else {
        return false;
      }
    }
  }
};
